"use client";

import Link from "next/link";
import { trackEvent } from "@/components/analytics";
import type { ComponentProps } from "react";

type TrackedLinkProps = ComponentProps<typeof Link> & {
  eventAction: string;
  eventCategory: string;
  eventLabel?: string;
};

export function TrackedLink({
  eventAction,
  eventCategory,
  eventLabel,
  onClick,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      // Marks this link as already instrumented so the delegated blog CTA
      // tracker in `BlogCtaTracking` does not emit a second event for it.
      data-tracked=""
      onClick={(e) => {
        trackEvent(eventAction, eventCategory, eventLabel);
        onClick?.(e);
      }}
    />
  );
}
